import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig, DialogComponent, PageService, Shell } from '@tytapp/common';
import { environment } from '@tytapp/environment';
import { UserService } from '../user.service';

@Component({
    selector: 'tyt-user-auth-mediator',
    templateUrl: './user-auth-mediator.component.html',
    styleUrls: ['./user-auth-mediator.component.scss']
})
export class UserAuthMediatorComponent extends DialogComponent {

    @Input() title: string = "Let's start!";
    enableYouTubeLogin: boolean;

    constructor(
        private readonly pageService: PageService,
        private readonly userService: UserService,
        shell: Shell,
        readonly route: Router,
        private appConfig: AppConfig
    ) {
        super(pageService);
    }

    async init(pageTitle?: string) {
        if (pageTitle && typeof pageTitle == 'string') this.title = pageTitle;
        this.enableYouTubeLogin = await this.appConfig.featureEnabled('apps.web.enable_youtube_login');
    }

    oauthUrlFor(provider: string): string {
        let queryString = this.buildQuery({
            app: 'web',
            source: this.userService.source || 'login',
            source_first_time: this.userService.sourceFirstTime ? 'true' : 'false',
            return_url: `/login/return?method=login`
        });

        return `${environment.urls.platform}/sign-in-with/${provider}?${queryString}`;
    }

    private buildQuery(params: Record<string, any>): string {
        return Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
    }

    public close() {
        this.shell.hideDialog();
    }
}
